import {
    getScopeValuesByField,
    hasFilterScope,
} from 'components/SentenceFilter/helpers';
import { useTranslation } from 'react-i18next';
import { useGetScopes } from 'routes/BudgetModule/shared/useGetScopes';
import { useGetUserScopes } from 'routes/BudgetModule/shared/useGetUserScopes';

/**
 * Add scopes informations to the budget filter in order to allow filtering by perimeters.
 */
export const useAddScopesToAnalyzeFilters = (
    filters: SentenceFilterWithScopesT[],
): SentenceFilterWithScopesT[] => {
    const userScopes = useGetUserScopes();
    const scopes = useGetScopes();
    const { t } = useTranslation();
    return filters.map((filter) => {
        if (hasFilterScope(filter.field, userScopes, scopes)) {
            return {
                ...filter,
                scopes: getScopeValuesByField(
                    filter.field,
                    userScopes,
                    t,
                    scopes,
                ),
            };
        }
        return filter;
    });
};
